exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.expand-enter-active[data-v-6ef36be8],\n.expand-leave-active[data-v-6ef36be8] {\n    transition: all 0.2s ease;\n    overflow: hidden;\n}\n.expand-enter[data-v-6ef36be8],\n.expand-leave-to[data-v-6ef36be8] {\n    opacity: 0;\n    max-height: 0;\n}\n.expand-enter-to[data-v-6ef36be8],\n.expand-leave[data-v-6ef36be8] {\n    opacity: 1;\n    max-height: 2000px;\n}\n", ""]);

// exports
